var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlechaHaciaAbajoSidenav(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "24/Flechas/Abajo 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.43051 8.70194C4.70003 8.38741 5.1735 8.35092 5.48803 8.62045L11.7112 13.9532C11.8793 14.0989 12.1207 14.0989 12.2888 13.9532L12.292 13.9504L18.512 8.62045C18.8265 8.35092 19.3 8.38741 19.5695 8.70194C19.839 9.01647 19.8026 9.48994 19.488 9.75946L13.2712 15.0867L13.2694 15.0883C12.5381 15.7205 11.4618 15.7205 10.7306 15.0882L4.512 9.75946C4.19747 9.48994 4.16098 9.01647 4.43051 8.70194Z",
    fill: "#3677DE"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlechaHaciaAbajoSidenav);
export default __webpack_public_path__ + "static/media/FlechaHaciaAbajoSIDENAV.ce898d4fb4ae1c6064797c073c411d12.svg";
export { ForwardRef as ReactComponent };